import { mapAutoManufactureYears, mapBrands, mapAutoModels } from 'shared/lib/mapDictionaries';

import type { TPledgeAutoFormIncomingDictionaries } from '../types';

import { mapPowers } from './mapPowers';

export const mapDictionary = (payload: Partial<TPledgeAutoFormIncomingDictionaries>) => {
  const { brand, brands, model, models, powers, year, years } = payload ?? {};
  const brandId = brand?.id ?? undefined;
  const modelId = model?.id ?? undefined;
  const currentYear = year ?? undefined;

  return {
    models: mapAutoModels({ brandId }, models),
    years: mapAutoManufactureYears({ modelId }, years),
    powers: mapPowers({ brandId, modelId, year: currentYear }, powers),
    brands: mapBrands(brands),
  };
};
